import React, { useState, useEffect } from 'react';
import { fetchSubAccountsList } from '../../api/metrics';
import SearchDropdown from './searchDropdown';

interface SubAccount {
  contact: {
    company_name: string;
  };
  subaccount_number: string;
}

interface Props {
  setSelectedSubAccount: (subAccount: string) => void;
  selectedSubAccount: string;
  label?: string;
  placeholder?: string;
  setHandleToggleChange?: any;
  firstOption?: any;
  className?: any;
}

const SelectSubAccountDropdown: React.FC<Props> = ({
  selectedSubAccount,
  setSelectedSubAccount,
  label,
  placeholder,
  setHandleToggleChange,
  firstOption,
  className,
}: Props) => {
  const [accountList, setAccountList] = useState<SubAccount[]>([]);
  useEffect(() => {
    const fetchData = async () => {
      let payload = {
        is_pagination: false,
      };
      try {
        const response = await fetchSubAccountsList(payload);
        if (!response?.data?.is_error) {
          const accountData: any = response.data.content;
          const formattedAccountList: any = accountData.map((item: any) => ({
            label: item.contact.company_name,
            value: item.subaccount_number,
          }));
          setAccountList(formattedAccountList);
        }
      } catch (error) {}
    };

    fetchData();
  }, []);

  return (
    <SearchDropdown
      id={'account-dropdown'}
      className={className && className}
      placeholder={placeholder ? placeholder : 'Select account here'}
      selectedValue={selectedSubAccount}
      dummyOptionText={firstOption ? firstOption : 'Select account here'}
      label={label && label}
      options={accountList && accountList}
      onSelect={(item) => {
        setSelectedSubAccount(item.value);
        setHandleToggleChange && setHandleToggleChange(true);
      }}
    />
  );
};

export default SelectSubAccountDropdown;
